import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyCardBusinessType = (
  property: IPropertyDetailsResponse
) => {
  return property.business_type;
};
